import { render, staticRenderFns } from "./TheAcademyCapIcon.vue?vue&type=template&id=9c1f9c76&scoped=true&"
import script from "./TheAcademyCapIcon.vue?vue&type=script&lang=js&"
export * from "./TheAcademyCapIcon.vue?vue&type=script&lang=js&"
import style0 from "./TheAcademyCapIcon.vue?vue&type=style&index=0&id=9c1f9c76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1f9c76",
  null
  
)

export default component.exports